<template functional>
  <div class="playlist-group-thumbnail" @mouseenter="listeners['mouseenter']()" @mouseleave="listeners['mouseleave']()">
    <transition name="fade">
      <div v-if="props.segmentType !== 'smile' && props.isInfoOpen" class="playlist-group-thumbnail__info">
        <h2 v-if="!props.isShort">{{ props.playlistGroup.title }}</h2>

        <div>
          <age-badge :age="props.playlistGroup.minAge" />
          <season-count v-if="!props.isShort" :amount="props.playlistGroup.playlists.length" />
          <h2 v-else>{{ props.playlistGroup.title }}</h2>
        </div>

        <development-tags v-if="props.playlistGroup.tags.length > 0" :tags="props.playlistGroup.tags" inline />
      </div>
    </transition>

    <img :src="props.backgroundImage" loading="lazy" :alt="props.playlistGroup.description" @load="evt => listeners['backgroundImageLoaded'](evt)" />
  </div>
</template>

<script>
export default {
  name: 'playlist-group-thumbnail',
  props: {
    isInfoOpen: Boolean,
    playlistGroup: Object,
    segmentType: String,
    backgroundImage: String
  }
}
</script>

<style lang="scss">
.playlist-group-thumbnail {
  transition: box-shadow 0.3s;
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  width: 320px;
  height: 210px;
  background-color: #C4C4C4;

  &--loaded {
    background-color: transparent;
  }

  &__info {
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    background: linear-gradient(180deg, rgba(37, 37, 37, 0.3) 0%, rgba(37, 37, 37, 0.7) 40%, rgba(37, 37, 37, 0.9) 100%);
    transition: opacity .3s ease;
    padding: 16px;
    color: white;
    text-decoration: none;

    &.fade-enter-active, &.fade-leave-active {
      opacity: 1
    }

    &.fade-enter, &.fade-leave-to {
      opacity: 0;
    }

    & > h2, & > div > h2 {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 1.5rem;
      margin-bottom: 5px;
    }

    & > div {
      display: inline-flex;
      align-items: center;
    }

    & > .development-tags {
      font-size: 0.9rem;
      line-height: 0.9rem;
      margin-top: 18px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      overflow: hidden;
    }
  }

  img {
    width: inherit;
    height: inherit;
    object-fit: cover;
    border-radius: inherit;
  }

  @media (hover: none),
         (max-width: 425px) and (orientation: portrait),
         (max-width: 812px) and (orientation: landscape) {
    width: 150px;
    height: 110px;

    &__info {
      display: none;
    }
  }
}
</style>
